/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

import ThemePartList from '../containers/theme/ThemePartList';

import Footer from '../components/Footer';
//import ViewContent from '../containers/main/ViewContent';
import $ from 'jquery';
class AttackOnTitan extends Component {
  componentDidMount = () => {
    window.addEventListener('resize', this._getWindowSize);
    //this._getWindowSize()
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $('img[usemap]').rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('resize', this._getWindowSize);
  };
  _goContent = () => {
    const { setContentSerial } = this.props;
    setContentSerial(2377);
  };
  render() {
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div style={{ paddingTop: 80 }}>
          <img
            src={imgUrl + '/img/event/20201117/theme_1120.png'}
            style={{ width: '100%' }}
            useMap="#FPMap0"
          />
          <map name="FPMap0">
            <area
              style={{ cursor: 'pointer' }}
              onClick={this._goContent}
              shape="rect"
              coords="1483, 713, 1802, 802"
            />
          </map>
        </div>
        <div style={{ marginTop: -70 }}>
          <ThemePartList themeSerial={12} />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(AttackOnTitan));
